import PaymentChevronDown from "icons/PaymentChevronDown";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";

type DetailsSummaryAccordionItemProps = {
  title: string;
  description: any;
  className?: string;
  index: number;
  addDivider?: boolean;
  dividerClassname?: string;
  isLastItem?: boolean;
  isPlusCategories?: boolean;
  defaultFirstOpen?: boolean;
};

const DetailsSummaryAccordionItem = ({
  title,
  description,
  className,
  index,
  addDivider = true,
  dividerClassname = "",
  isLastItem = false,
  isPlusCategories,
  defaultFirstOpen = false,
}: DetailsSummaryAccordionItemProps): JSX.Element => {
  const handleToggle = (e: React.SyntheticEvent<HTMLDetailsElement>) => {
    const details = e.currentTarget;
    const isOpen = details.open;

    if (isOpen) {
      details.classList.add("active");
    } else {
      details.classList.remove("active");
    }
  };

  return (
    <div className={`${className || ""} accordion-item`} key={index}>
      <details
        className="details-accordion"
        onToggle={handleToggle}
        {...(defaultFirstOpen && index === 0 && { open: true })}
      >
        <summary className="accordion-header">
          {title}
          <div className="chevron">
            <PaymentChevronDown />
          </div>
        </summary>
        <div className="accordion-body">{description}</div>
      </details>

      {isPlusCategories ? (
        <>
          {addDivider && !isLastItem && (
            <div className={formatClassNames(dividerClassname, "accordion-devider")} />
          )}
        </>
      ) : (
        <>
          {addDivider && (
            <div className={formatClassNames(dividerClassname, "accordion-devider")} />
          )}
        </>
      )}
    </div>
  );
};

export default wrapperHOC(DetailsSummaryAccordionItem, {
  componentName: "FAQs-DetailsSummaryAccordionItem",
  showForChina: true,
});
